import {
  GET_MAPPER_MODEL_ID,
  POST_MAPPER_BASIC_MAPPER,
  POST_MAPPER_FILES,
  GET_MAPPER_FILES,
  SET_MAPPER_FILES,
  SET_MAPPER_FILES_LOADER,
  DELETE_MAPPER_FILES,
  SET_MAPPER_MODELS,
  GET_MAPPER_MODELS,
  SET_MAPPER_MODEL_ID,
  SET_MAPPER_DATA,
  SUCCESS_MAPPER_BASIC_MAPPER,
  SET_ERROR_MAPPER,
  GET_MAPPER_TEMPLATES,
  SET_MAPPER_TEMPLATES,
  POST_MAPPER_TEMPLATE,
  DELETE_MAPPER_TEMPLATE,
  PATCH_MAPPER_TEMPLATE,
  GET_MAPPER_TEMPLATE,
  SET_MAPPER_TEMPLATE,
  SET_TEMPLATE_ERROR,
  POST_MAPPER_VALIDATION,
  SET_MAPPER_VALIDATION,
  SHOW_VALIDATION_PROCESS,
  HIDE_VALIDATION_PROCESS,
  SET_MAPPER_VALIDATION_SUCCESS,
  SHOW_LOAD_BASIC_MAPPER,
} from "./actionTypes";

export const setLoadBasicMapper = status => ({
  type: SHOW_LOAD_BASIC_MAPPER,
  payload: status,
});

export const getMapperValidation = (id, data, model, platform) => ({
  type: POST_MAPPER_VALIDATION,
  payload: { id, data, model, platform },
});

export const setMapperValidation = data => ({
  type: SET_MAPPER_VALIDATION,
  payload: data,
});

export const setMapperValidationSuccess = type => ({
  type: SET_MAPPER_VALIDATION_SUCCESS,
  payload: type,
});

export const showValidationProcess = () => ({
  type: SHOW_VALIDATION_PROCESS,
});

export const hideValidationProcess = () => ({
  type: HIDE_VALIDATION_PROCESS,
});

export const getMapperTemplates = content_type => ({
  type: GET_MAPPER_TEMPLATES,
  payload: content_type,
});

export const setMapperTemplates = data => ({
  type: SET_MAPPER_TEMPLATES,
  payload: data,
});

export const getMapperTemplate = id => ({
  type: GET_MAPPER_TEMPLATE,
  payload: id,
});

export const setMapperTemplate = data => ({
  type: SET_MAPPER_TEMPLATE,
  payload: data,
});

export const addMapperTemplate = data => ({
  type: POST_MAPPER_TEMPLATE,
  payload: data,
});

export const deleteMapperTemplate = (id, content_type) => ({
  type: DELETE_MAPPER_TEMPLATE,
  payload: { id, content_type },
});

export const updateMapperTemplate = data => ({
  type: PATCH_MAPPER_TEMPLATE,
  payload: data,
});

export const addMapperFiles = data => ({
  type: POST_MAPPER_FILES,
  payload: data,
});

export const setMapperData = data => ({
  type: SET_MAPPER_DATA,
  payload: data,
});

export const getMapperModels = () => ({
  type: GET_MAPPER_MODELS,
});

export const setMapperModels = data => ({
  type: SET_MAPPER_MODELS,
  payload: data,
});

export const getMapperModelId = id => ({
  type: GET_MAPPER_MODEL_ID,
  payload: id,
});

export const setMapperModelID = data => ({
  type: SET_MAPPER_MODEL_ID,
  payload: data,
});

export const postModelBasicMapping = data => ({
  type: POST_MAPPER_BASIC_MAPPER,
  payload: data,
});

export const successMapping = type => ({
  type: SUCCESS_MAPPER_BASIC_MAPPER,
  payload: type,
});

export const setErrorMapping = type => ({
  type: SET_ERROR_MAPPER,
  payload: type,
});

export const uploadTemplateError = type => ({
  type: SET_TEMPLATE_ERROR,
  payload: type,
});

export const getMapperFiles = (data) => ({
  type: GET_MAPPER_FILES,
  payload: data
});

export const deleteMapperFile = (id) => ({
  type: DELETE_MAPPER_FILES,
  payload: id,
});

export const setMapperFileLoader = data => ({
  type: SET_MAPPER_FILES_LOADER,
});

export const setMapperFiles = data => ({
  type: SET_MAPPER_FILES,
  payload: data,
});
